import { render, staticRenderFns } from "./Exposants.vue?vue&type=template&id=db35b52a&scoped=true&"
import script from "./Exposants.vue?vue&type=script&lang=js&"
export * from "./Exposants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db35b52a",
  null
  
)

export default component.exports